module.exports = __webpack_public_path__ + "images/illustrations/illustration-soccer@2x-9efa9c4553e935871858646383083e73.webp";